// This API supports using CryptoCompare or CoinGecko as data providers. For both, the free API is used, in an unauthen-
// ticated fashion, i.e. without api keys. Rate limits are determined based on the user's IP. The current recommendation
// is to use CryptoCompare as provider because its rate limits are significantly more generous, and CoinGecko does not
// allow fetching historic rates past the last 365 days on the free API.
export var Provider;
(function (Provider) {
    Provider["CryptoCompare"] = "CryptoCompare";
    Provider["CoinGecko"] = "CoinGecko";
})(Provider || (Provider = {}));
export var RateType;
(function (RateType) {
    RateType["CURRENT"] = "current";
    RateType["HISTORIC"] = "historic";
})(RateType || (RateType = {}));
// Note that CryptoCompare and CoinGecko support many more but these are the ones that are currently of interest to us.
export var CryptoCurrency;
(function (CryptoCurrency) {
    CryptoCurrency["NIM"] = "nim";
    CryptoCurrency["BTC"] = "btc";
    CryptoCurrency["ETH"] = "eth";
    CryptoCurrency["USDC"] = "usdc";
})(CryptoCurrency || (CryptoCurrency = {}));
// This enum has been generated from the generated lists CRYPTOCOMPARE_FIAT_CURRENCIES, COINGECKO_FIAT_CURRENCIES and
// BRIDGEABLE_FIAT_CURRENCIES defined below via the following script:
//
// const CRYPTOCOMPARE_FIAT_CURRENCIES = [ ...as defined below ];
// const COINGECKO_FIAT_CURRENCIES = [ ...as defined below ];
// const BRIDGEABLE_FIAT_CURRENCIES = [ ...as defined below ];
// const allFiatCurrencies = [...new Set([
//     ...CRYPTOCOMPARE_FIAT_CURRENCIES,
//     ...COINGECKO_FIAT_CURRENCIES,
//     ...BRIDGEABLE_FIAT_CURRENCIES,
// ])].sort();
// const currencyNameFormatter = new Intl.DisplayNames('en-US', { type: 'currency' });
// console.log(allFiatCurrencies.map((currency) => `${currency} = '${currency.toLowerCase()}', `
//     + `// ${currencyNameFormatter.of(currency)}`).join('\n'));
export var FiatCurrency;
(function (FiatCurrency) {
    FiatCurrency["AED"] = "aed";
    FiatCurrency["AFN"] = "afn";
    FiatCurrency["ALL"] = "all";
    FiatCurrency["AMD"] = "amd";
    FiatCurrency["ANG"] = "ang";
    FiatCurrency["AOA"] = "aoa";
    FiatCurrency["ARS"] = "ars";
    FiatCurrency["AUD"] = "aud";
    FiatCurrency["AWG"] = "awg";
    FiatCurrency["AZN"] = "azn";
    FiatCurrency["BAM"] = "bam";
    FiatCurrency["BBD"] = "bbd";
    FiatCurrency["BDT"] = "bdt";
    FiatCurrency["BGN"] = "bgn";
    FiatCurrency["BHD"] = "bhd";
    FiatCurrency["BIF"] = "bif";
    FiatCurrency["BMD"] = "bmd";
    FiatCurrency["BND"] = "bnd";
    FiatCurrency["BOB"] = "bob";
    FiatCurrency["BRL"] = "brl";
    FiatCurrency["BSD"] = "bsd";
    FiatCurrency["BTN"] = "btn";
    FiatCurrency["BWP"] = "bwp";
    FiatCurrency["BYN"] = "byn";
    FiatCurrency["BZD"] = "bzd";
    FiatCurrency["CAD"] = "cad";
    FiatCurrency["CDF"] = "cdf";
    FiatCurrency["CHF"] = "chf";
    FiatCurrency["CLP"] = "clp";
    FiatCurrency["CNY"] = "cny";
    FiatCurrency["COP"] = "cop";
    FiatCurrency["CRC"] = "crc";
    FiatCurrency["CUP"] = "cup";
    FiatCurrency["CVE"] = "cve";
    FiatCurrency["CZK"] = "czk";
    FiatCurrency["DJF"] = "djf";
    FiatCurrency["DKK"] = "dkk";
    FiatCurrency["DOP"] = "dop";
    FiatCurrency["DZD"] = "dzd";
    FiatCurrency["EGP"] = "egp";
    FiatCurrency["ERN"] = "ern";
    FiatCurrency["ETB"] = "etb";
    FiatCurrency["EUR"] = "eur";
    FiatCurrency["FJD"] = "fjd";
    FiatCurrency["FKP"] = "fkp";
    FiatCurrency["GBP"] = "gbp";
    FiatCurrency["GEL"] = "gel";
    FiatCurrency["GHS"] = "ghs";
    FiatCurrency["GIP"] = "gip";
    FiatCurrency["GMD"] = "gmd";
    FiatCurrency["GNF"] = "gnf";
    FiatCurrency["GTQ"] = "gtq";
    FiatCurrency["GYD"] = "gyd";
    FiatCurrency["HKD"] = "hkd";
    FiatCurrency["HNL"] = "hnl";
    FiatCurrency["HTG"] = "htg";
    FiatCurrency["HUF"] = "huf";
    FiatCurrency["IDR"] = "idr";
    FiatCurrency["ILS"] = "ils";
    FiatCurrency["INR"] = "inr";
    FiatCurrency["IQD"] = "iqd";
    FiatCurrency["IRR"] = "irr";
    FiatCurrency["ISK"] = "isk";
    FiatCurrency["JMD"] = "jmd";
    FiatCurrency["JOD"] = "jod";
    FiatCurrency["JPY"] = "jpy";
    FiatCurrency["KES"] = "kes";
    FiatCurrency["KGS"] = "kgs";
    FiatCurrency["KHR"] = "khr";
    FiatCurrency["KMF"] = "kmf";
    FiatCurrency["KPW"] = "kpw";
    FiatCurrency["KRW"] = "krw";
    FiatCurrency["KWD"] = "kwd";
    FiatCurrency["KYD"] = "kyd";
    FiatCurrency["KZT"] = "kzt";
    FiatCurrency["LAK"] = "lak";
    FiatCurrency["LBP"] = "lbp";
    FiatCurrency["LKR"] = "lkr";
    FiatCurrency["LRD"] = "lrd";
    FiatCurrency["LSL"] = "lsl";
    FiatCurrency["LYD"] = "lyd";
    FiatCurrency["MAD"] = "mad";
    FiatCurrency["MDL"] = "mdl";
    FiatCurrency["MGA"] = "mga";
    FiatCurrency["MKD"] = "mkd";
    FiatCurrency["MMK"] = "mmk";
    FiatCurrency["MNT"] = "mnt";
    FiatCurrency["MOP"] = "mop";
    FiatCurrency["MRU"] = "mru";
    FiatCurrency["MUR"] = "mur";
    FiatCurrency["MVR"] = "mvr";
    FiatCurrency["MWK"] = "mwk";
    FiatCurrency["MXN"] = "mxn";
    FiatCurrency["MYR"] = "myr";
    FiatCurrency["MZN"] = "mzn";
    FiatCurrency["NAD"] = "nad";
    FiatCurrency["NGN"] = "ngn";
    FiatCurrency["NIO"] = "nio";
    FiatCurrency["NOK"] = "nok";
    FiatCurrency["NPR"] = "npr";
    FiatCurrency["NZD"] = "nzd";
    FiatCurrency["OMR"] = "omr";
    FiatCurrency["PAB"] = "pab";
    FiatCurrency["PEN"] = "pen";
    FiatCurrency["PGK"] = "pgk";
    FiatCurrency["PHP"] = "php";
    FiatCurrency["PKR"] = "pkr";
    FiatCurrency["PLN"] = "pln";
    FiatCurrency["PYG"] = "pyg";
    FiatCurrency["QAR"] = "qar";
    FiatCurrency["RON"] = "ron";
    FiatCurrency["RSD"] = "rsd";
    FiatCurrency["RUB"] = "rub";
    FiatCurrency["RWF"] = "rwf";
    FiatCurrency["SAR"] = "sar";
    FiatCurrency["SBD"] = "sbd";
    FiatCurrency["SCR"] = "scr";
    FiatCurrency["SDG"] = "sdg";
    FiatCurrency["SEK"] = "sek";
    FiatCurrency["SGD"] = "sgd";
    FiatCurrency["SHP"] = "shp";
    FiatCurrency["SOS"] = "sos";
    FiatCurrency["SRD"] = "srd";
    FiatCurrency["SSP"] = "ssp";
    FiatCurrency["STN"] = "stn";
    FiatCurrency["SYP"] = "syp";
    FiatCurrency["SZL"] = "szl";
    FiatCurrency["THB"] = "thb";
    FiatCurrency["TJS"] = "tjs";
    FiatCurrency["TMT"] = "tmt";
    FiatCurrency["TND"] = "tnd";
    FiatCurrency["TOP"] = "top";
    FiatCurrency["TRY"] = "try";
    FiatCurrency["TTD"] = "ttd";
    FiatCurrency["TWD"] = "twd";
    FiatCurrency["TZS"] = "tzs";
    FiatCurrency["UAH"] = "uah";
    FiatCurrency["UGX"] = "ugx";
    FiatCurrency["USD"] = "usd";
    FiatCurrency["UYU"] = "uyu";
    FiatCurrency["UZS"] = "uzs";
    FiatCurrency["VES"] = "ves";
    FiatCurrency["VND"] = "vnd";
    FiatCurrency["VUV"] = "vuv";
    FiatCurrency["WST"] = "wst";
    FiatCurrency["XAF"] = "xaf";
    FiatCurrency["XCD"] = "xcd";
    FiatCurrency["XOF"] = "xof";
    FiatCurrency["XPF"] = "xpf";
    FiatCurrency["YER"] = "yer";
    FiatCurrency["ZAR"] = "zar";
    FiatCurrency["ZMW"] = "zmw";
})(FiatCurrency || (FiatCurrency = {}));
// Fiat currencies supported by CryptoCompare.
// This list has been generated by reducing the supported currencies to those that are listed as a circulating currency
// on https://en.wikipedia.org/wiki/List_of_circulating_currencies#List_of_circulating_currencies_by_state_or_territory
// via the following script:
//
// const referenceCurrencySymbols = { ...parsed from Wikipedia as described in CurrencyInfo.ts };
// const CryptoCurrency = { ...as defined above };
// const CRYPTOCOMPARE_CURRENT_RATES_FIAT_CURRENCIES = [ ...as defined below (ticker strings only) ];
// const CRYPTOCOMPARE_HISTORIC_RATES_FIAT_CURRENCIES = [ ...as defined below (ticker strings only) ];
//
// async function _fetch(url, init) {
//     const result = await fetch(url, init).then((response) => response.json());
//     if (result?.Message?.includes('rate limit')) {
//         console.log('Pausing on rate limit...');
//         await new Promise((resolve) => setTimeout(resolve, 3500));
//         return _fetch(url, init);
//     }
//     return result;
// }
//
// async function _isSupportedCurrency(currency, forHistoricRates) {
//     const fiatApiCryptoCurrencies = Object.keys(CryptoCurrency).join(',');
//     // For historic rates use CCCAGG exchange / data set, the default used by CryptoCompare for historic rates.
//     const exchangeParameter = forHistoricRates ? '&e=CCCAGG' : ''
//     const { Message: errorMessage } = await _fetch('https://min-api.cryptocompare.com/data/pricemulti'
//         + `?fsyms=${fiatApiCryptoCurrencies}&tsyms=${currency}${exchangeParameter}&relaxedValidation=false`);
//     if (errorMessage?.includes('market does not exist')) {
//         return false;
//     } else if (errorMessage) {
//         throw new Error(`Currency ${currency} check failed because of unexpected error: ${errorMessage}`);
//     }
//     return true;
// }
//
// let knownFiatCurrencyEntries = [];
// let page = 1; // starts at 1
// let lastPage; // inclusive
// const pageSize = 100; // the max allowed page size
// do {
//     const { Data: {
//         LIST: entries,
//         STATS: { TOTAL_ASSETS: fiatCurrencyCount },
//     } } = await _fetch('https://data-api.cryptocompare.com/asset/v1/top/list'
//         + `?asset_type=FIAT&sort_by=CREATED_ON&sort_direction=ASC&page=${page}&page_size=${pageSize}`);
//     knownFiatCurrencyEntries = knownFiatCurrencyEntries.concat(entries);
//     lastPage = Math.ceil(fiatCurrencyCount / pageSize);
// } while (++page <= lastPage);
//
// const collator = new Intl.Collator('en');
// knownFiatCurrencyEntries.sort(({ SYMBOL: s1}, { SYMBOL: s2 }) => collator.compare(s1, s2));
//
// const supportedCurrentRatesFiatCurrencyEntries = [];
// const supportedHistoricRatesFiatCurrencyEntries = [];
// for (const entry of knownFiatCurrencyEntries) {
//     const { SYMBOL: currency, NAME: name } = entry;
//     if (!(currency in referenceCurrencySymbols)) {
//         console.log(`Currency ${currency} (${name}) is skipped because it's not circulating.`);
//         continue;
//     }
//     if (await _isSupportedCurrency(currency, /* forHistoricRates */ false)) {
//         supportedCurrentRatesFiatCurrencyEntries.push(entry);
//     }
//     if (await _isSupportedCurrency(currency, /* forHistoricRates */ true)) {
//         supportedHistoricRatesFiatCurrencyEntries.push(entry);
//     }
// }
//
// console.log('Supported currencies for current rates:');
// console.log(supportedCurrentRatesFiatCurrencyEntries.map(({ SYMBOL: currency }) => `'${currency}'`).join(', '));
// for (const currency of CRYPTOCOMPARE_CURRENT_RATES_FIAT_CURRENCIES) {
//     if (supportedCurrentRatesFiatCurrencyEntries.some(({ SYMBOL }) => SYMBOL === currency)) continue;
//     console.warn(`Previously supported ${currency} is not supported or circulating anymore.`);
// }
// console.log('Supported currencies for historic rates:');
// console.log(supportedHistoricRatesFiatCurrencyEntries.map(({ SYMBOL: currency }) => `'${currency}'`).join(', '));
// for (const currency of CRYPTOCOMPARE_HISTORIC_RATES_FIAT_CURRENCIES) {
//     if (supportedHistoricRatesFiatCurrencyEntries.some(({ SYMBOL }) => SYMBOL === currency)) continue;
//     console.warn(`Previously supported ${currency} is not supported or circulating anymore.`);
// }
const CRYPTOCOMPARE_CURRENT_RATES_FIAT_CURRENCIES = [
    'AED', 'AOA', 'ARS', 'AUD', 'BGN', 'BND', 'BOB', 'BRL', 'BYN', 'CAD', 'CHF', 'CLP', 'CNY', 'COP', 'CZK', 'DKK',
    'ERN', 'EUR', 'GBP', 'GEL', 'HKD', 'HUF', 'IDR', 'ILS', 'INR', 'JPY', 'KRW', 'KZT', 'MNT', 'MXN', 'MYR', 'NGN',
    'NOK', 'NZD', 'PEN', 'PHP', 'PLN', 'RON', 'RUB', 'SEK', 'SGD', 'STN', 'THB', 'TRY', 'UAH', 'UGX', 'USD', 'VUV',
    'ZAR', 'ZMW',
].map((ticker) => FiatCurrency[ticker]);
const CRYPTOCOMPARE_HISTORIC_RATES_FIAT_CURRENCIES = [
    'AED', 'ARS', 'AUD', 'BRL', 'CAD', 'CHF', 'COP', 'CZK', 'EUR', 'GBP', 'GEL', 'IDR', 'ILS', 'INR', 'JPY', 'KRW',
    'KZT', 'MXN', 'MYR', 'NGN', 'NZD', 'PLN', 'RON', 'RUB', 'SGD', 'THB', 'TRY', 'UAH', 'USD', 'ZAR',
].map((ticker) => FiatCurrency[ticker]);
// Fiat currencies supported by CoinGecko, all of which support historic rates.
// Note that CoinGecko supports more vs_currencies (see https://api.coingecko.com/api/v3/simple/supported_vs_currencies)
// but also includes crypto currencies and ounces of gold amongst others that are not fiat currencies. This list here
// has been generated by reducing the vs_currencies to those that are listed as a circulating currency on
// https://en.wikipedia.org/wiki/List_of_circulating_currencies#List_of_circulating_currencies_by_state_or_territory
// via the following script:
//
// const referenceCurrencySymbols = { ...parsed from Wikipedia as described in CurrencyInfo.ts };
// const COINGECKO_FIAT_CURRENCIES = [ ...as defined below (ticker strings only) ];
//
// const coinGeckoCurrencies = (await fetch('https://api.coingecko.com/api/v3/simple/supported_vs_currencies')
//     .then((response) => response.json()))
//     .map((currency) => currency.toUpperCase())
//     .filter((currency) => currency in referenceCurrencySymbols)
//     .sort();
//
// console.log('Supported currencies:');
// console.log(coinGeckoCurrencies.map((currency) => `'${currency}'`).join(', '));
// for (const currency of COINGECKO_FIAT_CURRENCIES) {
//     if (coinGeckoCurrencies.includes(currency)) continue;
//     console.warn(`Previously supported ${currency} is not supported or circulating anymore`);
// }
const COINGECKO_FIAT_CURRENCIES = [
    'AED', 'ARS', 'AUD', 'BDT', 'BHD', 'BMD', 'BRL', 'CAD', 'CHF', 'CLP', 'CNY', 'CZK', 'DKK', 'EUR', 'GBP', 'GEL',
    'HKD', 'HUF', 'IDR', 'ILS', 'INR', 'JPY', 'KRW', 'KWD', 'LKR', 'MMK', 'MXN', 'MYR', 'NGN', 'NOK', 'NZD', 'PHP',
    'PKR', 'PLN', 'RUB', 'SAR', 'SEK', 'SGD', 'THB', 'TRY', 'TWD', 'UAH', 'USD', 'VND', 'ZAR',
].map((ticker) => FiatCurrency[ticker]);
// Additionally supported fiat currencies, for which we calculate exchange rates by combining coin/USD and fiat/USD
// rates via the CPL API, if they're not directly supported by the chosen provider. These do not support historic rates.
// This list is designed to not overlap with HISTORY_BRIDGEABLE_FIAT_CURRENCIES, to prefer the history supporting APIs,
// and it has been generated by reducing the supported currencies to those that are listed as a circulating currency on
// https://en.wikipedia.org/wiki/List_of_circulating_currencies#List_of_circulating_currencies_by_state_or_territory via
// the following script:
//
// const referenceCurrencySymbols = { ...parsed from Wikipedia as described in CurrencyInfo.ts };
// const HISTORY_BRIDGEABLE_FIAT_CURRENCIES = [ ... as defined below (ticker strings only) ];
// const CPL_BRIDGEABLE_FIAT_CURRENCIES = [ ...as defined below (ticker strings only) ];
//
// const cplData = await fetch('https://firestore.googleapis.com/v1/projects/checkout-service/databases/(default)/'
//     + 'documents/exchangerates/rates').then((response) => response.json());
// const cplCurrencies = Object.keys(cplData.fields.rates.mapValue.fields)
//     .map((currency) => currency.toUpperCase())
//     .filter((currency) => currency in referenceCurrencySymbols
//         && !HISTORY_BRIDGEABLE_FIAT_CURRENCIES.includes(currency))
//     .sort();
//
// console.log('Supported currencies:');
// console.log(cplCurrencies.map((currency) => `'${currency}'`).join(', '));
// for (const currency of CPL_BRIDGEABLE_FIAT_CURRENCIES) {
//     if (cplCurrencies.includes(currency)) continue;
//     console.warn(`Previously supported ${currency} is not supported or circulating anymore`);
// }
const CPL_BRIDGEABLE_FIAT_CURRENCIES = [
    'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF',
    'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHF', 'CLP', 'CNY', 'COP', 'CUP',
    'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GHS', 'GIP',
    'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD',
    'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD',
    'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MYR', 'MZN', 'NAD', 'NGN',
    'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB',
    'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SOS', 'SRD', 'SSP', 'STN', 'SYP', 'SZL', 'THB', 'TJS',
    'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'UYU', 'UZS', 'VES', 'VND', 'VUV', 'WST',
    'XAF', 'XCD', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMW',
].map((ticker) => FiatCurrency[ticker]);
// Additionally supported fiat currencies, for which we calculate exchange rates by combining coin/USD and fiat/USD
// rates, if they're not directly supported by the chosen provider. The currencies here support historic rates. This
// list is maintained manually.
const HISTORY_BRIDGEABLE_FIAT_CURRENCIES = ['CRC'].map((ticker) => FiatCurrency[ticker]);
// Additionally supported fiat currencies, for which we calculate exchange rates by combining coin/USD and fiat/USD
// rates, if they're not directly supported by the chosen provider. Not all of these are supported for fetching
// historical exchange rates. Those that are, are listed in HISTORY_BRIDGEABLE_FIAT_CURRENCIES and all currencies that
// are supported for fetching historical exchange rates via a specific provider, bridged or not, can be checked for via
// isHistorySupportedFiatCurrency(currency, provider).
const BRIDGEABLE_FIAT_CURRENCIES = [
    ...CPL_BRIDGEABLE_FIAT_CURRENCIES,
    ...HISTORY_BRIDGEABLE_FIAT_CURRENCIES,
];
// Previously, when we supported CoinGecko as the only exchange rate provider, BridgeableFiatCurrency was designed such
// that it did not overlap with CoinGeckoFiatCurrency, i.e. overlapping entries were omitted in BridgeableFiatCurrency.
// With the introduction of CryptoCompare as an additional provider with a different set of supported currencies, we
// changed its definition to include all supported currencies, including those overlapping with currencies supported by
// either of the providers. Shall the API be reduced to only support one provider in the future, a check similar to the
// one below can be enabled again:
// Check that no currency supported directly by CoinGecko is handled as bridged currency. See description of
// __expectNoCplWithHistoryBridgeOverlap.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// type __expectNoCoinGeckoWithBridgedOverlap = {}[Extract<BridgeableFiatCurrency, CoinGeckoFiatCurrency>];
const HISTORY_BRIDGEABLE_CURRENCY_TIMEZONES = {
    [FiatCurrency.CRC]: 'America/Costa_Rica',
};
const API_URL_CRYPTOCOMPARE = 'https://min-api.cryptocompare.com/data';
let API_URL_COINGECKO = 'https://api.coingecko.com/api/v3';
const COIN_IDS_COINGECKO = {
    [CryptoCurrency.NIM]: 'nimiq-2',
    [CryptoCurrency.BTC]: 'bitcoin',
    [CryptoCurrency.ETH]: 'ethereum',
    [CryptoCurrency.USDC]: 'usd-coin',
};
const ONE_MINUTE = 60 * 1000;
const ONE_HOUR = 60 * ONE_MINUTE;
const ONE_DAY = 24 * ONE_HOUR;
/**
 * @param url The URL to the CoinGecko v3 API.
 */
export function setCoinGeckoApiUrl(url = 'https://api.coingecko.com/api/v3') {
    API_URL_COINGECKO = url;
}
const coinGeckoExtraHeaders = new Map();
export function setCoinGeckoApiExtraHeader(name, value) {
    if (value !== false) {
        coinGeckoExtraHeaders.set(name, value);
    }
    else {
        coinGeckoExtraHeaders.delete(name);
    }
}
export async function getExchangeRates(cryptoCurrencies, vsCurrencies, provider = Provider.CryptoCompare) {
    // Make sure the currencies are lower case to match the enums (for users that might not be using typescript which
    // ensures that only valid currency tickers are passed).
    cryptoCurrencies = cryptoCurrencies.map((currency) => currency.toLowerCase());
    vsCurrencies = vsCurrencies.map((currency) => currency.toLowerCase());
    // vsCurrencies handled by the provider. Potentially extended by USD.
    const providerVsCurrencies = [];
    const bridgedVsCurrencies = [];
    for (const currency of vsCurrencies) {
        if (isProviderSupportedFiatCurrency(currency, provider, RateType.CURRENT)) {
            providerVsCurrencies.push(currency);
        }
        else if (isBridgedFiatCurrency(currency, provider, RateType.CURRENT)) {
            bridgedVsCurrencies.push(currency);
        }
        else {
            throw new Error(`Currency ${currency} not supported for provider ${provider}.`);
        }
    }
    // Check for bridged currencies and fetch their USD exchange rates
    let bridgedExchangeRatesPromise;
    if (bridgedVsCurrencies.length) {
        bridgedExchangeRatesPromise = _getBridgeableFiatCurrencyExchangeRates(bridgedVsCurrencies);
        // Bridged exchange rates are to USD, therefore we need to get the USD exchange rate.
        if (!providerVsCurrencies.includes(FiatCurrency.USD)) {
            providerVsCurrencies.push(FiatCurrency.USD);
        }
    }
    let providerExchangeRatesPromise;
    switch (provider) {
        case Provider.CryptoCompare:
            providerExchangeRatesPromise = (async () => {
                // The max allowed length of the /pricemulti api's tsyms parameter is 100 chars, which equates to 25
                // comma separated ticker symbols. If requesting more providerVsCurrencies, we need multiple requests.
                const maxBatchSize = 25;
                const batchPromises = [];
                for (let batchStart = 0; batchStart < providerVsCurrencies.length; batchStart += maxBatchSize) {
                    const batchVsCurrencies = providerVsCurrencies.slice(batchStart, Math.min(providerVsCurrencies.length, batchStart + maxBatchSize));
                    batchPromises.push(_fetch(`${API_URL_CRYPTOCOMPARE}/pricemulti`
                        + `?fsyms=${cryptoCurrencies.join(',')}&tsyms=${batchVsCurrencies.join(',')}`));
                }
                const result = {};
                for (const batch of await Promise.all(batchPromises)) {
                    // Tickers in CryptoCompare's result are uppercase. Map them back to our enums and merge everything.
                    for (const [cryptoCurrencyTicker, coinPrices] of Object.entries(batch)) {
                        const cryptoCurrency = cryptoCurrencyTicker.toLowerCase();
                        for (const [vsCurrencyTicker, exchangeRate] of Object.entries(coinPrices)) {
                            const vsCurrency = vsCurrencyTicker.toLowerCase();
                            result[cryptoCurrency] ||= {};
                            result[cryptoCurrency][vsCurrency] = exchangeRate;
                        }
                    }
                }
                return result;
            })();
            break;
        case Provider.CoinGecko: {
            // Note that providerVsCurrencies do not need to be converted to coin ids, even for crypto currencies.
            const coinIds = cryptoCurrencies.map((currency) => COIN_IDS_COINGECKO[currency]);
            providerExchangeRatesPromise = _fetch(`${API_URL_COINGECKO}/simple/price`
                + `?ids=${coinIds.join(',')}&vs_currencies=${providerVsCurrencies.join(',')}`, 
            // Run sequentially to avoid (re)trying many parallel requests waiting on CoinGecko's low rate limit.
            /* sequentially */ true).then((prices) => cryptoCurrencies.reduce((result, cryptoCurrency) => ({
                ...result,
                // Map CoinGecko coin ids back to CryptoCurrency enum.
                [cryptoCurrency]: prices[COIN_IDS_COINGECKO[cryptoCurrency]],
            }), {}));
            break;
        }
        default: throw new Error(`Unsupported provider ${provider}`);
    }
    const [exchangeRates, bridgedExchangeRates,] = await Promise.all([providerExchangeRatesPromise, bridgedExchangeRatesPromise]);
    // Add prices calculated from bridged exchange rates, if any.
    for (const [bridgedCurrency, bridgedExchangeRate] of Object.entries(bridgedExchangeRates || {})) {
        for (const coinPrices of Object.values(exchangeRates)) {
            const coinUsdPrice = coinPrices[FiatCurrency.USD];
            coinPrices[bridgedCurrency] = bridgedExchangeRate && coinUsdPrice
                ? bridgedExchangeRate * coinUsdPrice
                : undefined;
        }
    }
    // Strictly speaking, USD would need to be filtered out if it was added, but we skip that for code simplicity.
    return exchangeRates;
}
/**
 * Request historic exchange rates by range. Input and output timestamps are in milliseconds.
 *
 * Additional noted for CryptoCompare:
 * We currently return data at hourly resolution. However, minutely or daily data would also be possible, support for
 * which should then be added via an options object in the function signature, if needed.
 *
 * Additional notes for CoinGecko:
 * The free, public API limits historic exchange rates to the past 365 days. Requesting older data results in 401 -
 * Unauthorized errors. The time resolution of returned data depends on the chosen range. CoinGecko provides minutely
 * for ranges within 1 day from the current time, hourly data for any ranges between 1 day and 90 days (do not need to
 * be within 90 days from current time) and daily for ranges above 90 days. Note that minutely data is ~5-10 minutes
 * apart, hourly data about an hour.
 */
export async function getHistoricExchangeRatesByRange(cryptoCurrency, vsCurrency, from, // in milliseconds
to, // in milliseconds
provider = Provider.CryptoCompare) {
    let bridgedCurrency;
    let bridgedHistoricRatesPromise;
    if (isBridgedFiatCurrency(vsCurrency, provider, RateType.HISTORIC)
        && !isProviderSupportedFiatCurrency(vsCurrency, provider, RateType.HISTORIC)) {
        bridgedCurrency = vsCurrency;
        bridgedHistoricRatesPromise = _getHistoricBridgeableFiatCurrencyExchangeRatesByRange(bridgedCurrency, from, to);
        // Bridged exchange rates are to USD, therefore we need to get the USD exchange rate, too.
        vsCurrency = FiatCurrency.USD;
    }
    // from and to are expected in seconds.
    from = Math.floor(from / 1000);
    to = Math.ceil(to / 1000);
    let providerHistoricRatesPromise;
    switch (provider) {
        case Provider.CryptoCompare:
            providerHistoricRatesPromise = (async () => {
                let result = [];
                let batchToTs = to; // last timestamp to include in current batch; inclusive
                while (batchToTs >= from) {
                    // eslint-disable-next-line no-await-in-loop
                    const { Data: { TimeFrom: batchFromTs, Data: batch } } = await _fetch(`${API_URL_CRYPTOCOMPARE}/v2/histohour`
                        + `?fsym=${cryptoCurrency}&tsym=${vsCurrency}&toTs=${batchToTs}&limit=2000`);
                    const filteredAndTransformedBatch = [];
                    for (const { time, open } of batch) {
                        if (time < from)
                            continue;
                        filteredAndTransformedBatch.push([time * 1000, open]);
                    }
                    result = filteredAndTransformedBatch.concat(result);
                    batchToTs = batchFromTs - 1;
                }
                return result;
            })();
            break;
        case Provider.CoinGecko: {
            const coinId = COIN_IDS_COINGECKO[cryptoCurrency.toLowerCase()];
            // Note that timestamps returned by CoinGecko are already in ms, even though from and to were in seconds.
            providerHistoricRatesPromise = _fetch(`${API_URL_COINGECKO}/coins/${coinId}/market_chart/range`
                + `?vs_currency=${vsCurrency}&from=${from}&to=${to}`, 
            // Run sequentially to avoid (re)trying many parallel requests waiting on CoinGecko's low rate limit.
            /* sequentially */ true).then(({ prices }) => prices);
            break;
        }
        default: throw new Error(`Unsupported provider ${provider}`);
    }
    const [providerHistoricRates, bridgedHistoricRates,] = await Promise.all([
        providerHistoricRatesPromise,
        bridgedHistoricRatesPromise,
    ]);
    if (bridgedCurrency && bridgedHistoricRates) {
        // Convert exchange rates to bridged currency and omit entries for which no bridged exchange rate is available.
        return providerHistoricRates.map(([timestamp, coinUsdPrice]) => {
            const date = _getDateString(timestamp, HISTORY_BRIDGEABLE_CURRENCY_TIMEZONES[bridgedCurrency]);
            const bridgedHistoricRate = bridgedHistoricRates[date];
            return bridgedHistoricRate ? [timestamp, coinUsdPrice * bridgedHistoricRate] : null;
        }).filter((entry) => entry !== null);
    }
    return providerHistoricRates;
}
/**
 * Get historic exchange rates at specific timestamps in milliseconds.
 */
export async function getHistoricExchangeRates(cryptoCurrency, vsCurrency, timestamps, provider = Provider.CryptoCompare, options = {}) {
    const result = new Map();
    if (!timestamps.length)
        return result;
    timestamps.sort((a, b) => a - b);
    let prices;
    switch (provider) {
        case Provider.CryptoCompare:
            prices = await getHistoricExchangeRatesByRange(cryptoCurrency, vsCurrency, 
            // Prices are exactly 1h apart, choose from&to such we get earlier&later data point for interpolation.
            timestamps[0] - ONE_HOUR, timestamps[timestamps.length - 1] + ONE_HOUR, provider);
            break;
        case Provider.CoinGecko: {
            // To get the best possible time resolution, we split the timestamps into a chunk within at most 1 day from
            // now and the rest into additional 90 day chunks, see notes on getHistoricExchangeRatesByRange.
            const now = Date.now();
            const chunks = [];
            let timestampIndex = timestamps.length - 1;
            // Create one day chunk
            const disableMinutelyData = 'disableMinutelyData' in options ? !!options.disableMinutelyData : false;
            if (!disableMinutelyData && now - timestamps[timestamps.length - 1] < ONE_DAY - 15 * ONE_MINUTE) {
                // Has a timestamp within last day (minus safety margin in case our clock is slightly off).
                // As one day is calculated from now and not from the timestamp, we have to account for the difference
                // between now and the timestamp.
                const maxChunkLength = ONE_DAY - 15 * ONE_MINUTE - (now - timestamps[timestamps.length - 1]);
                const { chunk, searchEndIndex } = _findCoinGeckoTimestampChunk(timestamps, timestampIndex, maxChunkLength, 
                // Prices are 5-10 min apart, choose margin such we get earlier&later data point for interpolation.
                10 * ONE_MINUTE);
                chunks.push(chunk);
                timestampIndex = searchEndIndex;
            }
            // Create additional 90 day chunks
            while (timestampIndex >= 0) {
                const { chunk, searchEndIndex } = _findCoinGeckoTimestampChunk(timestamps, timestampIndex, 90 * ONE_DAY, 
                // Prices are ~1h apart, chose margin such we get earlier and later data point for interpolation.
                1.5 * ONE_HOUR);
                chunks.push(chunk);
                timestampIndex = searchEndIndex;
            }
            const fetchPromises = chunks.map(({ start, end }) => getHistoricExchangeRatesByRange(cryptoCurrency, vsCurrency, start, end, provider));
            prices = (await Promise.all(fetchPromises)).reduce((accumulated, singleResult) => [...singleResult, ...accumulated], []).sort((a, b) => a[0] - b[0]); // have to re-sort by timestamp as chunks might be overlapping
            break;
        }
        default: throw new Error(`Unsupported provider ${provider}`);
    }
    if (!prices.length)
        return result; // Happens if provider doesn't have data for any of the requested timestamps,
    // for example for days before the provider started collecting price info or for days in the future.
    // For every requested timestamp interpolate the price from the timestamps we got from the API
    let timestampIndex = 0;
    let priceIndex = 0;
    while (timestampIndex < timestamps.length) {
        // Search priceIndex at which predecessor price timestamp < our timestamp <= current price timestamp.
        const timestamp = timestamps[timestampIndex];
        while (priceIndex < prices.length && prices[priceIndex][0] < timestamp) {
            ++priceIndex;
        }
        if (priceIndex === 0 || priceIndex === prices.length) {
            // Can't interpolate. This should typically not happen as we try to include additional data points for
            // interpolation via an added time margin in our calls to getHistoricExchangeRatesByRange. However, this can
            // still occur in exceptional cases when the gap between two data points was larger than our margin or the
            // requested timestamp was before the provider even started recording price data or is in the future.
            const priceEntry = prices[Math.min(priceIndex, prices.length - 1)];
            if (Math.abs(timestamp - priceEntry[0]) < 2 * ONE_DAY && timestamp <= Date.now()) {
                // Accept the single price entry's price if it's within a limit of 2 days and we're not making
                // assumptions about the future.
                result.set(timestamp, priceEntry[1]);
            }
        }
        else {
            // Interpolate between priceIndex-1 and priceIndex
            const predecessorEntry = prices[priceIndex - 1];
            const currentEntry = prices[priceIndex];
            const timeDelta = currentEntry[0] - predecessorEntry[0];
            if (timeDelta < 2 * ONE_DAY) {
                // accept the interpolation if timeDelta is within 2 days (typically should be 1 hour).
                const priceDelta = currentEntry[1] - predecessorEntry[1];
                const interpolatedPrice = predecessorEntry[1]
                    + priceDelta * ((timestamp - predecessorEntry[0]) / timeDelta);
                result.set(timestamp, interpolatedPrice);
            }
        }
        ++timestampIndex; // Continue with next timestamp and check same priceIndex
    }
    return result;
}
function _findCoinGeckoTimestampChunk(timestamps, searchStartIndex, maxChunkLength, timeMargin) {
    maxChunkLength -= 2 * timeMargin;
    const end = timestamps[searchStartIndex];
    let start = end;
    let i = searchStartIndex - 1;
    while (i >= 0 && end - timestamps[i] < maxChunkLength) {
        start = timestamps[i];
        --i;
    }
    return {
        searchEndIndex: i,
        chunk: {
            start: start - timeMargin,
            end: end + timeMargin,
        },
    };
}
let _fetchLock = Promise.resolve(); // note: shared across _fetch calls, i.e. not specific to an api or bridge
async function _fetch(input, initOrSequentially, sequentially = false) {
    const init = typeof initOrSequentially !== 'boolean' ? initOrSequentially : undefined;
    sequentially = typeof initOrSequentially === 'boolean' ? initOrSequentially : sequentially;
    let unlock;
    if (sequentially) {
        const previousLock = _fetchLock;
        _fetchLock = new Promise((resolve) => { unlock = resolve; });
        await previousLock;
    }
    try {
        let result = null;
        do {
            let retry = true;
            let waitTime = 20000; // default wait time when user is offline
            try {
                // eslint-disable-next-line no-await-in-loop
                const response = await fetch(input, {
                    ...init,
                    headers: [
                        ...(init instanceof Headers || Array.isArray(init) ? init : Object.entries(init || {})),
                        ...coinGeckoExtraHeaders,
                    ],
                });
                if (response.status === 429) {
                    // CoinGecko returns responses with status 429 (Too Many Requests) when the rate limit is hit.
                    // CoinGecko allows a dynamic amount of requests per minute, typically around 5 requests per minute,
                    // and tells us in the response headers when our next minute starts, but unfortunately due to cors
                    // we can not access this information. Therefore, we blindly retry after waiting some time. Note
                    // that CoinGecko resets the quota solely based on their system time, i.e. independent of when we
                    // resend our request. Therefore, we do not waste time/part of our quota by waiting a bit longer.
                    waitTime = 15000;
                    throw new Error('Rate limit hit. Retrying...');
                }
                if (!response.ok) {
                    // On other error codes, do not retry, e.g. on status 401 (Unauthorized) for api calls that require
                    // an API key like CoinGecko requests of historic data older than 365 days.
                    retry = false;
                    throw new Error(`${response.status} - ${response.statusText}`);
                }
                // eslint-disable-next-line no-await-in-loop
                result = await response.json();
                if (result?.Response === 'Error' && result?.Message?.includes('rate limit')) {
                    // CryptoCompare returns responses with status 200 but an error result when the rate limit is hit.
                    // CryptoCompare allows for 20 requests per second, and up to 300 requests per minute, see stats on
                    // /stats/rate/limit. I.e. we could burst 20 requests every 4 seconds to reach 300 requests per min.
                    // We use a slightly shorter waitTime than that, to reduce the chances of wasting any of the limit,
                    // for requests that we initiate in sequential chunks instead of in parallel bursts, like history
                    // requests. We could optimize this, as the response includes more detailed info about which rate
                    // limit was hit, but it's probably not really necessary.
                    waitTime = 3000;
                    throw new Error(`Rate limit hit: ${result.Message || result.Response}. Retrying...`);
                }
                if (result?.Response === 'Error') {
                    // On other CryptoCompare errors, do not retry, e.g. for api calls that require an API key.
                    retry = false;
                    throw new Error(`CryptoCompare error: ${result.Message || result.Response}`);
                }
            }
            catch (e) {
                if (!retry)
                    throw e;
                // User might be offline, or we ran into the provider's rate limiting.
                // Note that we do not prioritize between our fetches, therefore they will be resolved in random order.
                // eslint-disable-next-line no-await-in-loop
                await new Promise((resolve) => { setTimeout(resolve, waitTime); });
            }
        } while (!result);
        return result;
    }
    finally {
        unlock?.();
    }
}
export function isProviderSupportedFiatCurrency(currency, provider, rateType) {
    const providerFiatCurrencies = {
        [Provider.CryptoCompare]: {
            [RateType.CURRENT]: CRYPTOCOMPARE_CURRENT_RATES_FIAT_CURRENCIES,
            [RateType.HISTORIC]: CRYPTOCOMPARE_HISTORIC_RATES_FIAT_CURRENCIES,
        }[rateType],
        [Provider.CoinGecko]: COINGECKO_FIAT_CURRENCIES,
    }[provider];
    return providerFiatCurrencies.includes(currency);
}
export function isBridgeableFiatCurrency(currency) {
    return BRIDGEABLE_FIAT_CURRENCIES.includes(currency);
}
export function isBridgedFiatCurrency(currency, provider, rateType) {
    return isBridgeableFiatCurrency(currency) && !isProviderSupportedFiatCurrency(currency, provider, rateType);
}
export function isHistorySupportedFiatCurrency(currency, provider) {
    return isProviderSupportedFiatCurrency(currency, provider, RateType.HISTORIC)
        || HISTORY_BRIDGEABLE_FIAT_CURRENCIES.includes(currency);
}
/**
 * Get today's exchange rates to USD. Rates can be undefined if the user's clock is in the future.
 */
async function _getBridgeableFiatCurrencyExchangeRates(bridgeableFiatCurrencies) {
    const apiPromises = [];
    // Note that history-bridgeable currencies and cpl-bridgeable currencies don't overlap by design.
    const historyBridgeableFiatCurrencies = HISTORY_BRIDGEABLE_FIAT_CURRENCIES
        .filter((c) => bridgeableFiatCurrencies.includes(c));
    if (historyBridgeableFiatCurrencies.length) {
        for (const currency of historyBridgeableFiatCurrencies) {
            apiPromises.push(_getHistoricBridgeableFiatCurrencyExchangeRatesByRange(currency, Date.now())
                .then((exchangeRates) => ({
                // There is only a single entry in exchangeRates, if any, which is for the current date.
                [currency]: Object.values(exchangeRates)[0],
            })));
        }
    }
    const cplBridgeableFiatCurrencies = CPL_BRIDGEABLE_FIAT_CURRENCIES
        .filter((c) => bridgeableFiatCurrencies.includes(c));
    if (cplBridgeableFiatCurrencies.length) {
        apiPromises.push(_fetch('https://firestore.googleapis.com/v1/projects/checkout-service/databases/(default)/documents/'
            + 'exchangerates/rates').then((exchangeRatesResponse) => {
            const exchangeRates = _parseCplExchangeRateResponse(exchangeRatesResponse);
            // Reduce to only the requested cplBridgeableFiatCurrencies.
            return cplBridgeableFiatCurrencies.reduce((result, currency) => ({
                ...result,
                [currency]: exchangeRates[currency],
            }), {});
        }));
    }
    const apiResults = await Promise.all(apiPromises);
    return apiResults.reduce((exchangeRates, apiResult) => ({
        ...exchangeRates,
        ...apiResult,
    }));
}
/**
 * Get historic exchange rates to USD.
 */
async function _getHistoricBridgeableFiatCurrencyExchangeRatesByRange(bridgeableFiatCurrency, from, // in milliseconds, inclusive
to = from) {
    if (!HISTORY_BRIDGEABLE_FIAT_CURRENCIES.includes(bridgeableFiatCurrency)) {
        // Currently only supported for CRC. Check for users that don't use typescript.
        throw new Error(`Unsupported bridgeable currency for historic rates: ${bridgeableFiatCurrency}`);
    }
    const timezone = HISTORY_BRIDGEABLE_CURRENCY_TIMEZONES[bridgeableFiatCurrency];
    const fromDate = _getDateString(from, timezone);
    const toDate = to === from ? fromDate : _getDateString(to, timezone);
    // Note: entries for future dates are omitted and thus basically undefined which is reflected in the return type.
    return _fetch(`https://usd-crc-historic-rate.deno.dev/api/rates/${fromDate}/${toDate}`);
}
/**
 * Format a timestamp as a YYYY-MM-DD date string in a desired timezone.
 */
function _getDateString(timestamp, timezone) {
    // Define as record such that ts warns us if an entry is missing
    const timezoneUtcOffsets = {
        'America/Costa_Rica': -6, // fixed offset all year, as Costa Rica has no daylight saving time.
    };
    const timezoneUtcOffset = timezoneUtcOffsets[timezone];
    if (timezoneUtcOffset === undefined) {
        // Arbitrary timezones could be supported via DateTimeFormat.formatToParts, but manually shifting the date is
        // computationally slightly cheaper.
        throw new Error(`Unsupported timezone ${timezone}`);
    }
    // Shift timestamp such that its UTC date equates the date in timezone.
    const shiftedDate = new Date(timestamp);
    shiftedDate.setHours(shiftedDate.getHours() + timezoneUtcOffset); // supports under-/overflow into prev/next day
    return shiftedDate.toISOString().split('T')[0];
}
function _parseCplExchangeRateResponse(response) {
    const parsed = _parseRawFirebaseResponse(response);
    if (!('rates' in parsed))
        throw new Error('Invalid FirebaseResponse');
    const result = {};
    for (const [key, value] of Object.entries(parsed.rates)) {
        if (typeof value !== 'number')
            throw new Error('Invalid FirebaseResponse');
        result[key.toLowerCase()] = value;
    }
    return result;
}
function _parseRawFirebaseResponse(response) {
    const result = {};
    for (const [key, value] of Object.entries(response.fields)) {
        result[key] = _parseRawFirebaseValue(value);
    }
    return result;
}
function _parseRawFirebaseValue(raw) {
    if ('mapValue' in raw) {
        const result = {};
        for (const [key, value] of Object.entries(raw.mapValue.fields)) {
            result[key] = _parseRawFirebasePrimitive(value);
        }
        return result;
    }
    if ('arrayValue' in raw) {
        return raw.arrayValue.values.map((value) => _parseRawFirebasePrimitive(value));
    }
    return _parseRawFirebasePrimitive(raw);
}
function _parseRawFirebasePrimitive(raw) {
    if ('doubleValue' in raw) {
        return raw.doubleValue;
    }
    if ('integerValue' in raw) {
        return parseInt(raw.integerValue, 10);
    }
    if ('stringValue' in raw) {
        return raw.stringValue;
    }
    if ('booleanValue' in raw) {
        return raw.booleanValue;
    }
    if ('nullValue' in raw) {
        return null;
    }
    throw new Error('Invalid FirebaseRawPrimitive');
}
//# sourceMappingURL=FiatApi.js.map